export enum ApplicationStatusEnum {
	None = 0,
	//Incomplete = 1, //Status in CRM.  The UI will use 'Initiated'
	Initiated = 1,
	Submitted = 2,
	QC_Review = 3,
	Panel_Review = 4,
	Board_Review = 5,
	Approved = 6,
	Rejected = 7,
	Pending = 8,
	Cancelled = 9,
	Pending_Payment = 10,
	Site_Review = 11,
	Need_Information = 12,
	Upgraded = 13,
	Renewed = 14
}

export class ApplicationStatus {
	static ToString(type: ApplicationStatusEnum) {
		let s = String(ApplicationStatusEnum[type]);
		s = s.replace("_", " ");
		return s;
	}

	static IndexOf(value: string) {
		return ApplicationStatusEnum[value.replaceAll(" ", "_")];
	}

	static get keys() {
		return Object.keys(ApplicationStatusEnum).sort((a, b) => {
			return ApplicationStatusEnum[a] - ApplicationStatusEnum[b];
		});
	} // sorting is required since the order of keys is not guaranteed.

	static getEnum(ordinal): ApplicationStatusEnum {
		switch (ordinal) {
			case -1:
			case "None":
				return ApplicationStatusEnum.None;
			case 1:
			case "Incomplete":
			case "Initiated":
				return ApplicationStatusEnum.Initiated;
			case 2:
			case "Submitted":
				return ApplicationStatusEnum.Submitted;
			case 3:
			case "QC Review":
				return ApplicationStatusEnum.QC_Review;
			case 4:
			case "Panel Review":
				return ApplicationStatusEnum.Panel_Review;
			case 5:
			case "Board Review":
				return ApplicationStatusEnum.Board_Review;
			case 6:
			case "Approved":
				return ApplicationStatusEnum.Approved;
			case 7:
			case "Rejected":
				return ApplicationStatusEnum.Rejected;
			case 8:
			case 12:
			case "Pending":
			case "Need Information":
				return ApplicationStatusEnum.Need_Information;
			case 9:
			case "Cancelled":
				return ApplicationStatusEnum.Cancelled;
			case 10:
			case "Pending Payment":
				return ApplicationStatusEnum.Pending_Payment;
			case 13:
			case "Upgraded":
				return ApplicationStatusEnum.Upgraded;
			default:
				return ApplicationStatusEnum.None;
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/application-status.enum.ts